"use client";

import { useEffect, useState } from "react";
import { useRouter, usePathname } from "next/navigation";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const router = useRouter();
  const pathname = usePathname();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    // Basic check for token existence. Real implementation would decode JWT or hit a /me endpoint
    const token = typeof window !== "undefined" ? localStorage.getItem("access_token") : null;
    
    const isAuthPage = pathname === "/login" || pathname === "/register";

    if (!token && !isAuthPage) {
      // Not logged in, trying to access protected route -> redirect to login
      router.replace("/login");
    } else if (token && isAuthPage) {
      // Logged in, trying to access auth page -> redirect to dashboard
      router.replace("/dashboard");
    } else {
      // Allowed
      // Use setTimeout to avoid synchronous setState inside useEffect React warning
      setTimeout(() => setIsAuthorized(true), 0);
    }
  }, [pathname, router]);

  // Show a loading state until authorization check completes
  if (!isAuthorized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return <>{children}</>;
}
